import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, HostBinding } from '@angular/core';
import { Observable } from 'rxjs';
import { MenuService } from '../../../services/menu/menu.service';
import { FlyoutType } from '../../../domain/menu.domain';

/**
 * The Menu Item Content Component
 *
 * This component contains the content of the menu item
 */
@Component({
  selector: 'td-wb-menu-item-content',
  templateUrl: 'item-content.component.html',
  styleUrls: ['item-content.component.scss'],
  imports: [
    NgClass,
    AsyncPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuItemContentComponent implements OnInit {

  @Input() flyoutType: FlyoutType;

  /**
   * Class for item inner content
   */
  @Input() contentType: string;

  @Input() singleColumn: boolean = false;

  @HostBinding('class') className: string;

  /**
   * Class for item inner content
   */
  itemContentInnerClass: string;

  menuWidthChange$: Observable<number>;

  /**
   * Class for item content
   */
  private itemContentClass: string;

  constructor(private menuService: MenuService) {
  }

  ngOnInit(): void {
    if (this.flyoutType !== undefined) {
      this.itemContentClass = 'td-wb-nav__' + this.flyoutType + '__content';
      this.itemContentInnerClass = 'td-wb-nav__' + this.flyoutType + '__content__inner';
    }
    if (this.flyoutType !== undefined && this.contentType !== undefined) {
      this.itemContentInnerClass += ' td-wb-nav__' + this.flyoutType + '__content__inner--' + this.contentType;
    }

    if (!this.singleColumn) {
      this.menuWidthChange$ = this.menuService.onMenuWidthChangeSubject;
    }

    this.className = this.itemContentClass + ' td-wb-menu-item-content';

    if (this.singleColumn) {
      this.className += ' td-wb-menu-item-content-single-column';
    }
  }
}
